/**
 * Role catalog (§5). `roles` is a GLOBAL system table: no tenant_id (invariant
 * I1 exemption, documented in the README), seeded once, read-only at runtime.
 */
export const ROLE_KEYS = [
    'super_admin',
    'tenant_admin',
    'compliance_manager',
    'analyst',
    'intake_officer',
    'auditor',
];
/** Role keys assignable on tenant endpoints. super_admin is platform-only. */
export const TENANT_ROLE_KEYS = ROLE_KEYS.filter((k) => k !== 'super_admin');
export const ROLE_SEEDS = [
    {
        key: 'super_admin',
        name: 'Super Administrador',
        description: 'Rol de plataforma: aprovisiona y administra entidades (tenants) y la operación global. No se asigna dentro de una entidad.',
        isPlatform: true,
        rank: 0,
    },
    {
        key: 'tenant_admin',
        name: 'Administrador de Entidad',
        description: 'Administra los usuarios y roles del tenant, configura la matriz de riesgo y los ajustes de la entidad. Consulta expedientes, validaciones, alertas, revisiones y la bitácora de riesgo; no trabaja expedientes ni ejecuta validaciones o screening.',
        isPlatform: false,
        rank: 1,
    },
    {
        key: 'compliance_manager',
        name: 'Gerente de Cumplimiento',
        description: 'Crea y trabaja expedientes, ejecuta validaciones y screening de listas (incluye medios adversos), gestiona alertas y revisiones, y configura la matriz de riesgo. No administra usuarios.',
        isPlatform: false,
        rank: 2,
    },
    {
        key: 'analyst',
        name: 'Oficial / Analista',
        description: 'Trabaja expedientes: actualiza casos, captura documentos, registra sujetos y beneficiarios, ejecuta validaciones y screening, y atiende alertas y revisiones. No crea expedientes desde cero, no administra usuarios ni configura la matriz de riesgo.',
        isPlatform: false,
        rank: 3,
    },
    {
        key: 'intake_officer',
        name: 'Oficial de Ingreso',
        description: 'Registra clientes y abre expedientes, captura documentos, sujetos y beneficiarios, solicita documentación y ejecuta validaciones. No ejecuta screening de listas ni resuelve alertas, y no configura la matriz de riesgo.',
        isPlatform: false,
        rank: 4,
    },
    {
        key: 'auditor',
        name: 'Auditor (Solo Lectura)',
        description: 'Solo lectura: consulta usuarios, expedientes, validaciones, alertas, revisiones, la matriz de riesgo y la bitácora de riesgo. No crea ni modifica ningún dato.',
        isPlatform: false,
        rank: 5,
    },
];
//# sourceMappingURL=roles.js.map